import React, { FunctionComponent, ReactNode, useMemo } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { Text, useIsCashTheme } from '@afterpaytouch/core'

import { useGetOrderTransactionQuery, useOrderRemainingSchedules } from '../../state'
import { isScheduleCompleted } from '../../state/orders/utils'
import { Money } from '../Money'

const I18N_NAMESPACE = ['common', 'orders']

interface OrderProgressProps {
  orderId: string
}

export const OrderProgress: FunctionComponent<OrderProgressProps> = ({ orderId }) => {
  const testNameSpace = 'order-progress'
  const isCashTheme = useIsCashTheme()
  const { t } = useTranslation(I18N_NAMESPACE)
  const { data } = useGetOrderTransactionQuery(orderId)
  const { paymentScheduleSet, orderSummary } = data ?? {}
  const remainingSchedules = useOrderRemainingSchedules(orderId)

  const schedulesDone = useMemo((): number => {
    let done = 0
    paymentScheduleSet?.forEach((schedule) => {
      if (isScheduleCompleted(schedule)) {
        done += 1
      }
    })
    return done
  }, [paymentScheduleSet])

  const renderProgress = (): ReactNode => {
    const divs = []

    // @ts-ignore: OPERATION BLEED STOPPER
    for (let i = 0; i < paymentScheduleSet?.length; i++) {
      const backgroundClass = isCashTheme ? 'bg-primary' : 'bg-dark'
      // @ts-ignore: OPERATION BLEED STOPPER
      divs.push(<div key={i} className={clsx(i < schedulesDone ? backgroundClass : '', 'flex-1 py-1')} data-testid={`${testNameSpace}-indicator`} />)
    }
    return divs
  }

  return (
    <div data-testid={testNameSpace}>
      <div className='bg-dark-prominent mb-4 flex overflow-hidden rounded-lg'>{renderProgress()}</div>
      <div className='flex justify-between'>
        <div className='text-left'>
          <Text renderAs='div'>{t('orders:paymentLabels:paid')}</Text>
          {/* @ts-ignore: OPERATION BLEED STOPPER */}
          <Money bold value={orderSummary?.totalPaid} size='XL' testNameSpace={`${testNameSpace}-paid`} />
        </div>
        <div className='text-right'>
          <Text renderAs='div' testNameSpace={`${testNameSpace}-remaining`}>
            {t('orders:orderProgress:remaining', { remaining: remainingSchedules?.length })}
          </Text>
          {/* @ts-ignore: OPERATION BLEED STOPPER */}
          <Money bold value={orderSummary?.totalOwed} size='XL' testNameSpace={`${testNameSpace}-owed`} />
        </div>
      </div>
    </div>
  )
}
